export default "__VITE_ASSET__BMm61Oh4__"